module.exports = __webpack_public_path__ + "static/media/29ADMSPC8.6bf746be.jpg";